import EndSlide from "./EndSlide";
export default EndSlide;